const TesseractPromise = import(/* webpackIgnore:true */"https://unpkg.com/tesseract.js@4.0.2/dist/tesseract.min.js").then(() => {
    return window["Tesseract"];
});

/*
const tesseractScript = document.createElement('script');
const TesseractPromise = new Promise(res => {
    tesseractScript.addEventListener('load', () => res(window["Tesseract"]));
});
tesseractScript.src = "https://unpkg.com/tesseract.js@4.0.2/dist/tesseract.min.js";
document.body.appendChild(tesseractScript);
*/

export { TesseractPromise };